function renderTooltip() {
  document.querySelectorAll('[data-toggle="tooltip"]').forEach((e) => new bootstrap.Tooltip(e));
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => new bootstrap.Tooltip(e));
}

document.addEventListener("DOMContentLoaded", () => {
  renderTooltip();
});
